import React, { useRef } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Box, Paper, AppBar, Toolbar, Typography, Button } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { addEditPromoBanner } from '../../../actions/promoBannerActions';
import AddEditPromoBanner from './../../AddEditPromoBanner/AddEditPromoBanner';
import Swal from 'sweetalert2';
import MainContentContainer from '../../MainContentContainer/MainContentContainer';

const PromoBannerAddEditPage = () => {
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isEdit = location.pathname.indexOf('edit') > -1;
  const formRef = useRef();

  const handleCancel = () => {
    navigate('/banners');
  };

  const handleSave = () => {
    const formData = formRef.current?.validateAndGetData();
    if (!formData) return;

    Swal.fire({
      title: "Saving...",
      animation: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });

    dispatch(addEditPromoBanner(JSON.stringify(formData), () => navigate('/banners')));
  };

  return (
    <MainContentContainer sx={{ paddingBottom: 4 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? `Edit Promo Banner` : 'Add New Promo Banner'}
          </Typography>
          <Button
            color="error"
            startIcon={<Cancel />}
            variant="contained"
            onClick={handleCancel}
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? "Update" : "Create"}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditPromoBanner ref={formRef} isEdit={isEdit} selectedId={id} />
        </Paper>
      </Box>
    </MainContentContainer>
  );
};

export default PromoBannerAddEditPage;
